export const Text = {
  baseStyle: {
    color: "darkBrand",
  },
};

export const Heading = {
  baseStyle: {
    color: "darkBrand",
  },
};